export default __webpack_public_path__ + "static/media/logo.16a3e4a3.png";